import { porTrasDoPastejoContent as c } from "./content";

export function Creators() {
  return (
    <section className="home-page-v2__section home-page-v2__section--equipe">
      <div className="home-page-v2__section-inner">
        <div className="home-page-v2__equipe-intro">
          <h2>{c.heading}</h2>
          <p>{c.intro}</p>
        </div>
        <div className="team-grid team-panel">
          {c.team.map((member, index) => (
            <div key={member.name} className="team-member-wrapper">
              <article>
                <div className="home-page-v2__team-photo-wrapper">
                  {member.image ? (
                    <img
                      className="home-page-v2__team-photo"
                      src={member.image}
                      alt={member.name}
                      width={240}
                      height={240}
                      style={{
                        objectPosition: "center top",
                        objectFit: "cover"
                      }}
                    />
                  ) : null}
                </div>
                <h3>{member.name}</h3>
                <p>{member.bio}</p>
              </article>
              {index !== c.team.length - 1 && <div className="team-separator" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
